<template>
    <div>
        <el-input ref="spinput" :value="valueStr" :placeholder="placeholder" clearable @clear="onClear" autocomplete="off"  @focus="on选择原材料()" v-if="showInput"></el-input>

        <elModal ref="原材料选择对话框">
            <div style="height:400px;max-height:600px;overflow: auto;position: relative;min-width:600px;">
                <div style="margin-bottom: 5px;background: gray;padding: 5px;">
                    <el-input type="text" size="small" style="width: 230px;margin-top: 5px;margin-left: 10px;" placeholder="名称搜索" v-model="搜索str" @focus="e=>e.currentTarget.select()">
                        <template slot="prepend">搜索:</template>
                    </el-input>
                </div>
                <ul>
                    <li v-for="(lb,index) in 原材料类别list.Where(a=>a.I_上级类别编号==0)" :key="index">
                        <div v-if="过滤原材料list.Where(a=>a.I_原材料类别编号==lb.I_原材料类别编号).length>0">
                            <div style="margin-bottom: 5px;background: lightgray;padding: 5px;">
                                {{lb.C_原材料类别名称}}
                                <el-button v-if="multiple" type="warning" size="small" @click="()=>{filter过滤原材料list.Where('$.I_原材料类别编号=='+lb.I_原材料类别编号).forEach(e=>{e.checked=true;})}">全选</el-button>
                                <el-button v-if="multiple" type="warning" size="small" @click="()=>{原材料list.Where('$.I_原材料类别编号=='+lb.I_原材料类别编号).forEach(e=>{e.checked=false;})}">全不选</el-button>
                            </div>
                            <ul>
                                <li v-for="(cp,index2) in 过滤原材料list.Where(a=>a.I_原材料类别编号==lb.I_原材料类别编号)" :key="index+'cp'+index2" style="display:inline-block;margin-right: 5px;margin-bottom: 5px;">
                                    <el-button style="min-width:100px;" class="longtext" :icon="cp.checked?'el-icon-check':''" :type="cp.checked?'primary':''" size="small" @click="()=>{if(multiple){cp.checked=!cp.checked}else{cp.checked=true;$refs.原材料选择对话框.submit()}}">({{cp.I_原材料编号}}){{cp.C_原材料名称}}</el-button>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </elModal>
    </div>
</template>

<script>
import { mapState2, mapActions } from "vuex-ext";

export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: '选择商品'
        },
        filter: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: '请选择商品'
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        //自定义
        customValue: {
            type: String,
            default: ''
        },
        showInput:{
            type: Boolean,
            default: false,
        },
        I_门店Id: {
            type: Number,
            default: 0
        },
    },
    
    computed: {
        ...mapState2(['当前商户', '所有门店list']),
        filter过滤原材料list() {
            let list = this.原材料list;
            list = list.Where(this.filter);
            return list;
        },
        过滤原材料list() {
            let list = this.原材料list;

            if (this.filter) list = list.Where(this.filter);

            if (this.搜索str) {
                let 搜索输入 = this.搜索str.toLowerCase();
                list = list.Where(a => (a.C_原材料名称 || '').includes(搜索输入) || (a.C_简拼 || '').includes(搜索输入) || (a.I_原材料编号 || '') == 搜索输入);
            }

            return list;
        },
        valueStr() {
            if (this.customValue) return this.customValue;
            let length = (this.value || []).length;
            if (length == 0) return '全部原材料';
            else return length + '个原材料';
        }
    },
    data() {
        return {
            搜索str: '',
            原材料list: [],
            原材料类别list: []
        }
    },
    async mounted() {
        await this.on获取原材料类别(this.I_门店Id);
        await this.获取原材料();
    },
    methods: {
        async on获取原材料类别(I_门店Id) {
            try {
                this.原材料类别list = [];
                let result = await this.$postAsync("/api/boss", {
                    cmd: "原材料类别_list",
                    I_商户Id: this.当前商户.I_商户Id,
                    I_门店Id: I_门店Id
                });
                
                if(result.data.length > 0){
                    this.原材料类别list = result.data
                    return
                } else {
                    let 当前配送中心 = this.所有门店list.FirstOrDefault((a) => a.I_门店Id == this.I_门店Id) || { I_门店Id: 0 };
                    let tmp上级门店 = this.所有门店list.FirstOrDefault((a) => a.I_门店Id == 当前配送中心.I_上级门店Id) || { I_门店Id: 0 };
                    return this.on获取原材料类别(tmp上级门店.I_门店Id);
                }
            } catch (error) {
                this.$Alert(error);
            }
        },
        async 获取原材料() {
            try {
                let result = await window.vm.$postAsync("/api/boss", {
                    cmd: "原材料_list",
                    I_商户Id: this.当前商户.I_商户Id,
                    I_门店Id: this.I_门店Id,
                    B_门店没有查商户: true,
                });
                this.原材料list = result.data;
            } catch (error) {
                this.$Alert(error);
            }
        },
        // ...mapActions(['获取原材料']),
        async on选择原材料() {
            try {
                let selectList = await this.fun选择原材料(this.value);
                // 确保返回的对象具有正确的属性
                const formattedList = selectList.Select(a => {
                    return {
                        I_原材料编号: a.I_原材料编号,
                        C_原材料名称: a.C_原材料名称,
                        I_门店Id: a.I_门店Id,
                        I_原材料类别编号: a.I_原材料类别编号
                    }
                });
                
                // 使用 $emit 正确更新父组件的值
                this.$emit('input', formattedList);
            } catch (error) {
                this.$refs.spinput.blur();
                this.$Alert(error);
            }
        },
        async fun选择原材料(value = []) {
            if (this.原材料list.length < 1) throw '没有原材料可以选择!';
            
            // 使用更安全的方式来设置 checked 属性
            this.原材料list.forEach(e => { 
                this.$set(e, 'checked', value.some(a => a.I_原材料编号 == e.I_原材料编号)); 
            });

            await this.$refs.原材料选择对话框.show({
                title: this.title,
                showCustomButton: true,
                customButtonText: '全部原材料',
                customClick: () => {
                    this.原材料list.forEach(e => { this.$set(e, 'checked', false); });
                    this.$refs.原材料选择对话框.submit();
                },
                beforeClose: () => {
                    try {
                        let 选择菜品 = this.原材料list.Where('$.checked');
                        //if (选择菜品.length < 1) throw '请选择商品!';
                        return true;
                    } catch (error) {
                        this.$Alert(error);
                    }
                    return false;
                }
            });

            let selectList = this.原材料list.Where('$.checked');
            if (!this.multiple) {
                return selectList[0];
            }
            return selectList;
        },
        onClear() {
            this.$emit('input', []);
        },
    }
}
</script>

<style>
</style>